export default "__VITE_ASSET__CtvL5xSK__"